import React from 'react';
import { Button, ModalIsland } from '@saviynt/design-system';
import cx from 'classnames';

import { useInvertedLocalize } from '../../shared/hooks';

export interface AuditLogMessagesProps {
  className?: string;
  title: string;
  subtitle: string;
  onClick?: () => void;
  buttonText?: string;
}

/**
 * Component for displaying audit log messages with a go back button.
 */
function AuditLogMessages({
  className,
  title,
  subtitle,
  onClick,
  buttonText,
}: AuditLogMessagesProps): React.ReactElement {
  const l = useInvertedLocalize();
  const defaultButtonText = buttonText ?? l('Go Back');

  return (
    <ModalIsland
      isOpen
      kind='critical'
      alertTitle={title}
      alertSubtitle={subtitle}
      primaryButton={
        <Button kind='filled' size='medium' onClick={onClick}>
          {defaultButtonText}
        </Button>
      }
      onClose={onClick}
      className={cx('Aag-AuditLogViewerError', className)}
    />
  );
}

AuditLogMessages.defaultProps = {
  className: undefined,
  onClick: () => window.history.back(),
  buttonText: undefined,
};

export default AuditLogMessages;
